export default "__VITE_ASSET__DNNpzBBa__"